import { FeatureType } from '@/models/features';
import { FeatureSlice } from '@/redux/slices/featureSlice';

export enum FeatureTypeSelectionsPanelEnum {
  SAVED = 'SAVED',
  CLAIMED = 'CLAIMED',
  PARCEL = 'PARCEL',
  FSA = 'FSA',
  UPLOAD = 'UPLOAD',
  REAL_ESTATE = 'REAL_ESTATE',
  COMP = 'COMP',
  BOUNDARY = 'BOUNDARY',
}

export enum FeatureGroupsEnum {
  BOUNDARIES = 'boundaries',
  COMPS = 'comps',
  REAL_ESTATE = 'real-estate',
  CUSTOMIZATIONS = 'customizations',
  DEED_PLOTTER = 'deed-plotter',
}

export enum FeatureTypeNonFeatureSliceEnum {
  CUSTOMIZATIONS = 'CUSTOMIZATIONS',
  DEED_PLOTTER = 'DEED_PLOTTER',
}

export type CombinedFeatureTypes =
  | FeatureTypeSelectionsPanelEnum
  | FeatureTypeNonFeatureSliceEnum;

export const featureTypeFeatureSliceMap: Record<
  FeatureTypeSelectionsPanelEnum,
  keyof FeatureSlice
> = {
  [FeatureTypeSelectionsPanelEnum.PARCEL]: 'parcels',
  [FeatureTypeSelectionsPanelEnum.FSA]: 'clus',
  [FeatureTypeSelectionsPanelEnum.COMP]: 'comps',
  [FeatureTypeSelectionsPanelEnum.SAVED]: 'saves',
  [FeatureTypeSelectionsPanelEnum.REAL_ESTATE]: 'realEstates',
  [FeatureTypeSelectionsPanelEnum.UPLOAD]: 'uploads',
  [FeatureTypeSelectionsPanelEnum.CLAIMED]: 'claims',
  [FeatureTypeSelectionsPanelEnum.BOUNDARY]: 'boundaries',
};

export const featureGroupToFeatureTypeMap: Partial<
  Record<FeatureGroupsEnum, FeatureType[]>
> = {
  [FeatureGroupsEnum.BOUNDARIES]: [
    FeatureType.BOUNDARY,
    FeatureType.PARCEL,
    FeatureType.CLU,
    FeatureType.UPLOAD,
  ],
  [FeatureGroupsEnum.REAL_ESTATE]: [FeatureType.REAL_ESTATE],
  [FeatureGroupsEnum.COMPS]: [FeatureType.COMP],
};

export const featureGroupTypes: Record<
  FeatureGroupsEnum,
  CombinedFeatureTypes[]
> = {
  [FeatureGroupsEnum.BOUNDARIES]: [
    FeatureTypeSelectionsPanelEnum.BOUNDARY,
    FeatureTypeSelectionsPanelEnum.PARCEL,
    FeatureTypeSelectionsPanelEnum.FSA,
    FeatureTypeSelectionsPanelEnum.UPLOAD,
  ],
  [FeatureGroupsEnum.COMPS]: [FeatureTypeSelectionsPanelEnum.COMP],
  [FeatureGroupsEnum.REAL_ESTATE]: [FeatureTypeSelectionsPanelEnum.REAL_ESTATE],
  [FeatureGroupsEnum.CUSTOMIZATIONS]: [
    FeatureTypeNonFeatureSliceEnum.CUSTOMIZATIONS,
  ],
  [FeatureGroupsEnum.DEED_PLOTTER]: [
    FeatureTypeNonFeatureSliceEnum.DEED_PLOTTER,
  ],
};

export const featureGroupTitles: Partial<Record<FeatureGroupsEnum, string>> = {
  [FeatureGroupsEnum.BOUNDARIES]: 'Boundaries',
};

export const featureTypeTitles: Record<CombinedFeatureTypes, string> = {
  [FeatureTypeNonFeatureSliceEnum.CUSTOMIZATIONS]: 'Customizations',
  [FeatureTypeSelectionsPanelEnum.SAVED]: 'Previously Saved',
  [FeatureTypeSelectionsPanelEnum.BOUNDARY]: 'Custom',
  [FeatureTypeSelectionsPanelEnum.UPLOAD]: 'Upload',
  [FeatureTypeSelectionsPanelEnum.PARCEL]: 'Parcel',
  [FeatureTypeSelectionsPanelEnum.FSA]: 'FSA',
  [FeatureTypeSelectionsPanelEnum.COMP]: 'Sold Land',
  [FeatureTypeSelectionsPanelEnum.REAL_ESTATE]: 'Listings',
  [FeatureTypeSelectionsPanelEnum.CLAIMED]: 'Owned',
  [FeatureTypeNonFeatureSliceEnum.DEED_PLOTTER]: 'Deed Plot',
};

export type CardProps<T> = {
  feature: T;
  idx: number;
};
